import { IBaseConfig } from "@models/form/base-config";
import {
  HardFormFieldTypeEnum,
  IHardFormField,
  IHardFormSelectParams,
} from "@hardcode-kz/ui";

export class GridWidgetSettingsConfig implements IBaseConfig {
  version = 1;
  customPlaceholder = "10px | 10% | auto";
  customBorderPlaceholder = "solid 1px white";

  fields: IHardFormField[] = [
    {
      title: "Размер",
      params: {
        direction: "row",
        fields: [
          {
            name: "width",
            type: HardFormFieldTypeEnum.Input,
            title: "base.width",
            placeholder: "100px | 100% | 100vw | auto",
          },
          {
            name: "height",
            type: HardFormFieldTypeEnum.Input,
            title: "base.height",
            placeholder: "100px | 100% | 100vh | auto",
          },
          {
            name: "padding",
            type: HardFormFieldTypeEnum.Input,
            title: "base.padding",
            placeholder: "10px 5px 0  20px | 10% 5% | 10px",
          },
          {
            name: "position",
            type: HardFormFieldTypeEnum.Select,
            title: "base.positionStyle",
            params: {
              options: [
                { id: "static", name: "Static" },
                { id: "relative", name: "Relative" },
                { id: "absolute", name: "Absolute" },
                {
                  id: "fixed",
                  name: "Fixed",
                },
                { id: "sticky", name: "Sticky" },
              ],
            },
          } as IHardFormField<IHardFormSelectParams>,
        ],
      },
    },
    {
      title: "Позиция",
      params: {
        direction: "row",
        fields: [
          {
            name: "top",
            type: HardFormFieldTypeEnum.Input,
            title: "base.top",
          },
          {
            name: "left",
            type: HardFormFieldTypeEnum.Input,
            title: "base.left",
          },
          {
            name: "bottom",
            type: HardFormFieldTypeEnum.Input,
            title: "base.bottom",
            placeholder: this.customPlaceholder,
          },
          {
            name: "right",
            type: HardFormFieldTypeEnum.Input,
            title: "base.right",
            placeholder: this.customPlaceholder,
          },
        ],
      },
    },
    {
      params: {
        direction: "row",
        templateColumns: "1fr 1fr 1fr 1fr",
        fields: [
          {
            name: "zIndex",
            type: HardFormFieldTypeEnum.Number,
            title: "base.zIndex",
          },
        ],
      },
    },
    {
      title: "Рамка",
      params: {
        direction: "row",
        fields: [
          {
            name: "bt",
            type: HardFormFieldTypeEnum.Input,
            title: "base.bt",
            placeholder: this.customBorderPlaceholder,
          },
          {
            name: "bl",
            type: HardFormFieldTypeEnum.Input,
            title: "base.bl",
            placeholder: this.customBorderPlaceholder,
          },
          {
            name: "bb",
            type: HardFormFieldTypeEnum.Input,
            title: "base.bb",
            placeholder: this.customBorderPlaceholder,
          },
          {
            name: "br",
            type: HardFormFieldTypeEnum.Input,
            title: "base.br",
            placeholder: this.customBorderPlaceholder,
          },
        ],
      },
    },
  ];
}
